import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {RecherchePage} from './RecherchePage'
import {ClientAdresseEdit} from '../shop/clients/pages/client/ClientAdresseEdit'
import {RecherchePiecePage} from './RecherchePiecePage'
import {VehiculesListPage} from './VehiculesListPage'

const VehiculesWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>
        <Route
          path='recherche'
          element={
            <>
              {/*<PageTitle*/}
              {/*  breadcrumbs={[*/}
              {/*    {title: 'Véhicules', path: '/vehicules', isSeparator: false, isActive: true},*/}
              {/*  ]}*/}
              {/*>*/}
              {/*  Recherche*/}
              {/*</PageTitle>*/}
              <RecherchePage />
            </>
          }
        />
        <Route
          path='pieces'
          element={
            <>
              {/*<PageTitle*/}
              {/*  breadcrumbs={[*/}
              {/*    {title: 'Véhicules', path: '/vehicules', isSeparator: false, isActive: true},*/}
              {/*  ]}*/}
              {/*>*/}
              {/*  Pièces*/}
              {/*</PageTitle>*/}
              <RecherchePiecePage />
            </>
          }
        />
        <Route
          path='vehicules'
          element={
            <>
              {/*<PageTitle*/}
              {/*  breadcrumbs={[*/}
              {/*    {title: 'Véhicules', path: '/vehicules', isSeparator: false, isActive: true},*/}
              {/*  ]}*/}
              {/*>*/}
              {/*  Véhicules*/}
              {/*</PageTitle>*/}
              <VehiculesListPage />
            </>
          }
        />
        <Route index element={<Navigate to='/vehicules/recherche' />} />
      </Routes>
    </>
  )
}

export {VehiculesWrapper}
